import store from "@/store";
import PassThrough from "../../views/pass-through.vue";
import userManagementList from "../../views/user-management/list.vue";
import userManagementViewUser from "../../views/user-management/view-user.vue";

import {
  ROLE_ADMIN,
  LAYOUT_ADMIN
} from "../../constants";

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    let user = JSON.parse(localStorage.getItem("user"));
    let allowed = 0;
    for (let i = 0; i < to.meta.permission.length; i++) {
      if (to.meta.permission[i] === user.accessLevel) {
        allowed = 1;
        next();
        return;
      }
    }
    if (allowed === 0) {
      next("/not-allowed");
      return;
    }
  }
  next("/sign-in");
};

const userManagementRouter = {
  path: "/user-management",
  component: PassThrough,
  meta: {
    layout: LAYOUT_ADMIN,
    permission: [
      ROLE_ADMIN,
    ],
  },
  children: [
    {
      path: "",
      name: "",
      component: userManagementList,
      beforeEnter: ifAuthenticated,
      meta: {
        layout: LAYOUT_ADMIN,
        permission: [
          ROLE_ADMIN,
        ],
        title: "User Management",
        subtitles: []
      },
    },
    {
      path: "view-user/:id",
      name: "View User Management",
      component: userManagementViewUser,
      beforeEnter: ifAuthenticated,
      meta: {
        layout: LAYOUT_ADMIN,
        permission: [
          ROLE_ADMIN,
        ],
        title: "User Management",
        subtitles: ["User list"]
      },
      props: true
    },
  ],
  beforeEnter: ifAuthenticated
};

export default userManagementRouter;